function DateFilterAction(el) {
    this.el = el;
    this.state = {};
    this.name = 'calendar'
}

DateFilterAction.prototype.render = function () {
    if (typeof this.state == 'string') {
        this.state = JSON.parse(this.state)
    }
    if (this.state?.dates?.length && this.state) {
        this.el.classList.add('active');
        var text = '', self = this;
        if (this.state.view === 'days') {
            if (this.state.dates.length > 2) {
                text = this.formatDate(this.state.dates[0]) + ' ... ' + this.formatDate(this.state.dates[this.state.dates.length - 1]);
            } else {
                text = this.getText(this.state.dates, function (arg) {
                    return self.formatDate(arg);
                });
            }
        }
        if (this.state.view === 'months') {
            text = this.getText(this.state.dates, function (arg) {
                return self.formatMount(arg)
            });
        }
        if (this.state.view === 'years') {
            text = this.getText(this.state.dates, function (arg) {
                return self.formatYear(arg);
            });
        }
        this.el.querySelector('.action__btn-text').innerText = text;
    } else {
        this.el.classList.remove('active');
        this.el.querySelector('.action__btn-text').innerText = 'Фильтр по дате';
        window._DATE_PICKER.data('datepicker').clear();
    }
};

DateFilterAction.prototype.getText = function (items, formatFn) {
    return items.reduce(function (acc, item) {
        if (acc === '') {
            return formatFn(item);
        }
        return acc + ', ' + formatFn(item);
    }, '');
};

DateFilterAction.prototype.setData = function (state) {
    this.state = state.hasOwnProperty(this.name) && state[this.name] ? state[this.name] : {dates: [], view: 'days'};
};

DateFilterAction.prototype.formatDate = function (strDate) {
    var date = new Date(strDate);
    return date.getDate() + ' ' + this.getMount(date.getMonth()) + ' ' + date.getFullYear();
};

DateFilterAction.prototype.formatMount = function (strDate) {
    var date = new Date(strDate);
    return this.getMount(date.getMonth(), true) + ' ' + date.getFullYear();
};

DateFilterAction.prototype.formatYear = function (strDate) {
    var date = new Date(strDate);
    return date.getFullYear();
};

DateFilterAction.prototype.getMount = function (mountNumber, singular) {
    if (singular) {
        return ['январь', 'февраль', "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"][mountNumber]
    }
    return ['января', 'февраля', "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"][mountNumber]
};

